import {TabContext, TabPanel} from '@mui/lab';
import {
  Box,
  Card,
  CardHeader,
  ClickAwayListener,
  Container,
  Snackbar,
  Stack,
  Tab,
  Tabs,
  Typography
} from '@mui/material';
import {useEffect, useState} from 'react';
import {alpha, useTheme} from '@mui/material/styles';
import FullFeaturedCrudGrid from 'src/components/datagrid/dataGridCrud';

const QAWrapperComponent = (props: any) => {
  const theme = useTheme();
  const {TABS, _column_data, gridData, title} = props;
  const [activeQuestion, setActiveQuestion] = useState('');
  const [activeTab, setActiveTab] = useState('');
  const [activeSubTab, setActiveSubTab] = useState('');

  const handleActiveTabChange = (event: any, value: any) => {
    setActiveTab(value);
    setActiveSubTab('');
  };
  const handleActiveSubTabChange = (event: any, value: any) => {
    setActiveSubTab(value);
  };

  const handleOnCellClick = (params: any, event: any) => {
    const question = _column_data?.column_questions?.[params?.field];
    if (question?.length) {
      setActiveQuestion(question);
    }
  };

  const renderSubTabsContent = (
    parent_tabName: string,
    tab_list: any,
    data: any
  ) => {
    const TABS_Obj = tab_list?.map((item: any) => ({
      value: item,
      label: item
    }));
    return (
      <TabContext
        value={
          activeSubTab?.length
            ? activeSubTab
            : (tab_list?.[0] ?? '') + parent_tabName
        }>
        <Tabs
          value={
            activeSubTab?.length
              ? activeSubTab
              : (tab_list?.[0] ?? '') + parent_tabName
          }
          onChange={handleActiveSubTabChange}
          sx={{
            px: 2.5,
            boxShadow: `inset 0 -2px 0 0 ${alpha(
              theme.palette.grey[500],
              0.08
            )}`
          }}>
          {TABS_Obj?.map((tab: any) => (
            <Tab
              key={(tab?.value ?? '') + parent_tabName}
              value={(tab?.value ?? '') + parent_tabName}
              label={tab.label}
              iconPosition="end"
            />
          ))}
        </Tabs>
        <Stack spacing={2}>
          {TABS_Obj?.map((tab_obj: any, subTab_index: number) => (
            <TabPanel
              key={subTab_index}
              value={(tab_obj?.value ?? '') + parent_tabName}>
              <Typography variant="h6" component="h1">
                {tab_obj?.value}
              </Typography>
              <FullFeaturedCrudGrid
                data={data?.[`_dataGrid_${subTab_index}`]}
                column_data={_column_data}
                onCellClick={handleOnCellClick}
                gridHeight="100%"
                initialState={props?.initialState}
              />
            </TabPanel>
          ))}
        </Stack>
      </TabContext>
    );
  };

  const renderTabContent = (tabs: any) => (
    <>
      {tabs?.map((tabObj: any, index: number) => (
        <TabPanel key={index} value={tabObj?.value}>
          {gridData?.[tabObj?.value]?.titles?.length > 0
            ? renderSubTabsContent(
                tabObj?.value,
                gridData?.[tabObj?.value]?.titles,
                gridData?.[tabObj?.value]
              )
            : Object.keys(gridData?.[tabObj?.value]).map((key, grid_index) => {
                if (key.includes('_dataGrid_')) {
                  return (
                    <>
                      <Typography variant="h6" component="h1">
                        {gridData?.[tabObj?.value]?.titles?.[grid_index]}
                      </Typography>
                      <FullFeaturedCrudGrid
                        data={gridData?.[tabObj?.value]?.[key]}
                        column_data={_column_data}
                        onCellClick={handleOnCellClick}
                        gridHeight="100%"
                        initialState={props?.initialState}
                      />
                    </>
                  );
                }
                return null;
              })}
        </TabPanel>
      ))}
    </>
  );

  useEffect(() => {
    setActiveTab(TABS?.[0]?.value);
  }, [TABS]);

  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        open={!!activeQuestion?.length}
        message={activeQuestion}
      />
      <Container sx={{maxWidth: '100% !important'}}>
        <Card>
          <CardHeader title={title} sx={{mb: 2}} />
          <TabContext value={activeTab}>
            <Tabs
              value={activeTab}
              onChange={handleActiveTabChange}
              sx={{
                px: 2.5,
                boxShadow: `inset 0 -2px 0 0 ${alpha(
                  theme.palette.grey[500],
                  0.08
                )}`
              }}>
              {TABS?.map((tab: any) => (
                <Tab
                  key={tab.value}
                  value={tab.value}
                  label={tab.label}
                  iconPosition="end"
                />
              ))}
            </Tabs>
            <Stack spacing={2}>
              <ClickAwayListener onClickAway={() => setActiveQuestion('')}>
                <Box>{renderTabContent(TABS)}</Box>
              </ClickAwayListener>
            </Stack>
          </TabContext>
        </Card>
      </Container>
    </div>
  );
};

export default QAWrapperComponent;
